import { SortOption } from './sortOption';

export class ChartSeries {
    name: string;
    type: string;
    colour: string;
    xData: Date[];
    yData: number[];

}

export class GridRow {
    id: string;
    name: string;
    deratingFactor: number;
    deratingFactorEditField: number;
    paymentCapPercent: number;
    stateOrder: number;
    stateCode: string;
    aggregationlevel: string;
    hasAlert: boolean;
    alertTooltip: string;
    alertColor: string;
    hasInfo: boolean;
    infoTooltip: string;
    subGridRows: string[];
    subExpanded: boolean;
    isVisibleOnGrid: boolean;
    isVisibleOnChart: boolean;
    chartColour: string;
    hasManualUpdates: boolean[];
    isTotalRow: boolean;
    isSubGrid: boolean;
    isSubGridAndIsVisible: boolean;
    bidExpanded: boolean;
    dataRows: DataRow[];
    clearedIntervals?: number[];
}

export class DataRow {
    isEditable: boolean;
    metaDataKey: string;
    showOnlyOnExpand: boolean;
    name: string;
    dataValues: number[];
    roundedDataValues: number[];
    rowSum: number;
    isOnChart: boolean;
    lineColour: string;
    lineCaption: string;
    isVisibleInGrid: boolean;
    typeOnChart: string;
    cellColours: string[];
    participationIndicators?: number[];
    cellTooltip: string[];
    fontColours: string[];
    shadeColours: string[];
    tooltip: string;
    showStatus: boolean;
}

export class ContextMenuItem {
    typeKey: string;
    functionKey: string;
    caption: string;
    isSeparator: boolean;
    includeForAggregatedView
    includeForDetailedView
}

export class OfferEntryData {
    columnHeaders: string[];
    columnEditable: boolean[];
    intervalTimes: Date[];
    intervalIds: number[];
    isOfferedToMarket: boolean[];
    level: string;
    gridRows: GridRow[];
    sortedGridRows: GridRow[];
    selectedSort: SortOption;
    sortOptions: SortOption[];
    additionalChartSeries: ChartSeries[];
    loadedPortfolioID: string;
    startTime: Date;
    endTime: Date;
    rowHeaderContextMenu: ContextMenuItem[];
    columnHeaderContextMenu: ContextMenuItem[];
    cellContextMenu: ContextMenuItem[];
    product: string;
}

export class SaveObject {
    level: string;
    id: string;
    dataType: string;
    date: string;
    intervals: number[];
    values: number[];
    product: string;
}



// WEBPACK FOOTER //
// ./src/app/core/models/offerEntryData.ts